import serverPath from "../utils/serverPath";

const clampLimit = (limit) => Math.max(1, Math.min(Number(limit) || 10, 20));

export async function searchUniversity({
  query = "",
  type = "all",
  lang = "en",
  page = 1,
  limit = 10,
  signal,
} = {}) {
  const params = new URLSearchParams();
  params.set("q", query);
  params.set("type", type);
  params.set("lang", lang);
  params.set("page", String(Math.max(1, Number(page) || 1)));
  params.set("limit", String(clampLimit(limit)));

  const response = await fetch(serverPath(`/search?${params.toString()}`), {
    method: "GET",
    signal,
  });
  const payload = await response.json();

  if (!response.ok || payload.status !== "success") {
    throw new Error(payload.message || "Search is temporarily unavailable.");
  }

  return payload.data;
}
